{
  "es": {
    "survey": {
      "actions": {
        "add": "Añadir nuevo",
        "addDescription": "Añadir descripción",
        "close": "Cerrar",
        "create": "Crear",
        "createNew": "Nueva",
        "delete": "Eliminar",
        "deleteCount": "Vas a eliminar {count} encuesta. ¿Seguro? | Vas a eliminar {count} encuestas. ¿Seguro?",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "delete_surveys": "Eliminar encuesta | Eliminar encuestas",
        "importTemplate": "Importar",
        "newSurvey": "Encuesta",
        "publish": "Publicar",
        "publishCustomer": "Publicar para clientes",
        "revokeAccess": "Revocar acceso",
        "save": "Guardar",
        "selectAll": "Seleccionar las {total} encuestas",
        "send": "Enviar",
        "sendCustomer": "Enviar al cliente",
        "submit": "Guardar",
        "surveys_collapse": "Contraer encuestas",
        "surveys_expand": "Expandir encuestas",
        "unSelectAll": "Limpiar selección.",
        "unpublish": "Despublicar"
      },
      "attributes": {
        "description": "Título interno",
        "title": "Tu pregunta"
      },
      "labels": {
        "NPSOverview": "Vista general del NPS",
        "NPSQuestion": "¿Qué probabilidad hay de que recomiendes {name} a un amigo o colega?",
        "addQuestion": "Pregunta",
        "answerRequired": "Respuesta (obligatoria)",
        "answer_later": "Responder más tarde",
        "answeredAt": "Respondido el",
        "average_score": "Puntuación media",
        "clientTeam": "El equipo de {name}",
        "comments": "¿Comentarios o sugerencias? (opcional)",
        "completedTime": "Respondida",
        "customer": "Cliente",
        "customer_status": "Estado",
        "detractors": "Detractores",
        "dissatisfied": "Insatisfecho",
        "extremelyLikely": "Extremadamente probable",
        "lets_go": "Empezar",
        "list": "Lista",
        "mostRecentAnswers": "Respuestas más recientes",
        "neither_satisfied_nor_dissatisfied": "Ni satisfecho ni insatisfecho",
        "neutrals": "Neutros",
        "noAnswers": "Todavía no hay respuestas",
        "noSurveyFeedback": "Sin comentarios ni sugerencias",
        "noSurveysYet": "Todavía no hay encuestas. Crea tu primera encuesta para empezar.",
        "noUnitsClick": "Todavía no hay unidades, haz clic aquí para añadir",
        "no_opinion": "Sin opinión",
        "notAtAllLikely": "Nada probable",
        "nps": "NPS",
        "numberAnswered": "{answered} de {total} respuestas",
        "obligatory": "Hacer la encuesta obligatoria para los clientes",
        "pendingSurveys": " Necesitamos tu opinión",
        "promoters": "Promotores",
        "publishNow?": "¿Publicar ahora?",
        "published": "Publicada",
        "publishedCount": "Publicar esta encuesta para el cliente | Publicar {count} encuestas para los clientes",
        "question": "Pregunta",
        "question_number": "Pregunta {current_number} de {total_questions}",
        "questions": "Preguntas",
        "respondents": "Sin encuestados | 1 encuestado | {count} encuestados",
        "response": "Respuesta",
        "responseTime": "Tiempo de respuesta",
        "responses": "Respuestas",
        "revokeAccessCount": "Revocar el acceso a esta encuesta para el cliente | Revocar el acceso a esta encuesta para {count} clientes",
        "satisfied": "Satisfecho",
        "saveExplainer": "¿Hacer esta encuesta visible para tus clientes? ¿O guardarla y publicarla más tarde?",
        "scoreBreakdown": "Desglose de la puntuación",
        "selectOneUnit": "Selecciona al menos 1 encuesta",
        "selectUnits": "Seleccionar unidades",
        "selected": "{selected} encuesta seleccionada. | {selected} encuestas seleccionadas.",
        "sendCount": "Enviar esta encuesta al cliente | Enviar encuestas a {count} clientes",
        "sendExplainer": "Tus clientes verán esto en su inicio",
        "sendNow?": "¿Enviar ahora?",
        "sent": "Enviada",
        "sentCustomer": "Enviada al cliente",
        "showSurveysFor": "Mostrar encuestas de",
        "showingResultsFor": "Mostrando resultados de",
        "step0Title": "¿Qué proyecto de plantilla y encuesta quieres usar?",
        "step2Subtitle": "Para que tus clientes sepan cuál es el propósito de esta encuesta",
        "step2Title": "Añade una breve introducción",
        "step3Subtitle": "Selecciona tu proyecto para incluir todas tus unidades a la vez.",
        "step3Title": "¿Para qué unidades quieres crear esta encuesta?",
        "survey": "Encuesta",
        "surveyAlreadyAnswered": "Ya se ha respondido a esta encuesta. Gracias por tu opinión.",
        "surveyAnswer": "Opinión",
        "surveyNotCompleted": "La encuesta todavía no está completada.",
        "surveys": "Encuestas",
        "surveysCount": "{count} encuesta | {count} encuestas",
        "surveys_all_projects": "Encuestas de todos los proyectos",
        "tabOverview": "Vista general",
        "tabSurveys": "Encuestas",
        "thankYou": "¡Gracias por tu opinión!",
        "title": "Pregunta",
        "titles_must_be_unique": "Hay preguntas duplicadas. ¡Las preguntas deben ser únicas!",
        "totalSelected": "Las {total} encuestas están seleccionadas.",
        "unanswered": "Sin responder",
        "unit": "Unidad",
        "unitSelected": "Todavía no hay ninguna unidad seleccionada | Una unidad seleccionada | {count} unidades seleccionadas",
        "units": "Unidades",
        "unitsWithoutSurvey": "{count} unidad sin encuesta | {count} unidades sin encuesta",
        "unpublishedCount": "Despublicar esta encuesta | Despublicar {count} encuestas",
        "very_dissatisfied": "Muy insatisfecho",
        "very_satisfied": "Muy satisfecho",
        "visibility": "Visibilidad",
        "yourAnswers": "Tus respuestas",
        "yourQuestion": "Tu pregunta"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Pide opinión a tus clientes",
            "title": "Crea tu primera encuesta"
          },
          "none": {
            "subtitle": "Pide opinión a tus clientes",
            "title": "No se han encontrado encuestas"
          }
        }
      },
      "toasts": {
        "bulk_create": "Encuesta creada correctamente | Encuestas creadas correctamente",
        "bulk_delete": "Encuesta eliminada correctamente | Encuestas eliminadas correctamente",
        "bulk_update": "Encuesta actualizada correctamente | Encuestas actualizadas correctamente",
        "update": "Encuesta actualizada correctamente"
      },
      "validation": {
        "needName": "Introduce una pregunta",
        "needQuestion": "Añade al menos 1 pregunta",
        "selectUnit": "Selecciona al menos 1 unidad"
      }
    }
  }
}
